import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    menu: {
      careersites: []
    }
  },
  mutations: {
    SET_MENU_CAREERSITES (store, val) {
      store.menu.careersites = val
    }
  },
  getters: {
    getMenuCareersites: (store) => {
      return store.menu.careersites
    }
  },
  actions: {
    /*
    setMenuCareersites
    carrega os careersites ativos exibidos no menu
    */
    setMenuCareersites ({commit, dispatch, getters, state}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/careersites`, {
        params: {
          status: 'active',
          sort: 'name',
          limit: 100
        }
      })
      .then((response) => {
        const careersites = (response.data.docs || [])
          .filter((item) => item.status === 'active' && item.careersite_url)
          .map((item) => ({
            _id: item._id,
            name: item.name,
            careersite_url: item.careersite_url
          }))

        commit('SET_MENU_CAREERSITES', careersites)
        return careersites
      })
      .catch(() => {
        // falha no menu não deve quebrar a aplicação; mantém a lista atual
        return getters.getMenuCareersites
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Menu.js